module.exports = "ok";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/bom/bomfile.js
 ** module id = 1
 ** module chunks = 0
 **/